import { useQuery } from '@tanstack/react-query';
import peopleService from '@/lib/api/people';

export function usePersonDetail(
  organizationId: string | undefined,
  email: string | undefined,
) {
  return useQuery({
    queryKey: ['person-detail', organizationId, email],
    queryFn: async () => {
      if (!organizationId || !email) throw new Error('Organization ID and email required');

      const response = await peopleService.getPersonDetail(organizationId, email);

      if (!response.success || !response.data) {
        throw new Error(response.error || 'Failed to fetch person detail');
      }

      return response.data;
    },
    enabled: !!organizationId && !!email,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
